import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const getPinStrength = (pin) => {
  let s = 0;
  if (pin.length >= 4) s += 40;
  if (pin.length >= 6) s += 20;
  if (/[A-Za-z]/.test(pin)) s += 20;
  if (/\d/.test(pin)) s += 20;
  return Math.min(s, 100);
};

const securityQuestions = [
  "Namba yako ya bahati ni ipi?",
  "Chakula unachokipenda zaidi ni kipi?",
  "Jina lako la utani ni lipi?",
  "Rangi unayoipenda zaidi ni ipi?",
  "What is your friend's name?",
  "What is the name of your first pet?",
  "What city were you born in?",
  "What is your mother's middle name?",
];

const EditField = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const username = localStorage.getItem("username");

  const [value, setValue] = useState(state.value || "");
  const [error, setError] = useState("");

  const isBirthday = state.field === "birthDay";
  const isPin = state.field === "withdrawalPIN";
  const isSecQuestion = state.field === "securityQuestion";

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const save = async () => {
    const ref = doc(db, "security", username);
    const snap = await getDoc(ref);
    const oldData = snap.exists() ? snap.data() : {};

    // 🎂 Birthday
    if (isBirthday) {
      if (!day || !month || !year) {
        setError("Chagua siku, mwezi na mwaka.");
        return;
      }

      await setDoc(ref, {
        ...oldData,
        username,
        birthDay: day,
        birthMonth: month,
        birthYear: year,
      });

      navigate(-1);
      return;
    }

    // 🔐 PIN
    if (isPin) {
      if (!oldData.securityAnswer) {
        setError("Weka kwanza neno la usalama.");
        return;
      }
      if (value.length < 4) {
        setError("PIN lazima iwe angalau tarakimu 4.");
        return;
      }
    }

    if (!value) {
      setError("Jaza taarifa sahihi.");
      return;
    }

    await setDoc(ref, {
      ...oldData,
      username,
      [state.field]: value,
    });

    navigate(-1);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>{state.label}</h2>

      {isBirthday ? (
        <>
          <select value={day} onChange={(e) => setDay(e.target.value)}>
            <option value="">Day</option>
            {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
              <option key={d}>{d}</option>
            ))}
          </select>

          <select value={month} onChange={(e) => setMonth(e.target.value)}>
            <option value="">Month</option>
            {[
              "January","February","March","April","May","June",
              "July","August","September","October","November","December",
            ].map((m) => (
              <option key={m}>{m}</option>
            ))}
          </select>

          <select value={year} onChange={(e) => setYear(e.target.value)}>
            <option value="">Year</option>
            {Array.from({ length: 100 }, (_, i) => 2025 - i).map((y) => (
              <option key={y}>{y}</option>
            ))}
          </select>
        </>
      ) : isSecQuestion ? (
        <select value={value} onChange={(e) => setValue(e.target.value)}>
          <option value="">-- Select Question --</option>
          {securityQuestions.map((q) => (
            <option key={q}>{q}</option>
          ))}
        </select>
      ) : (
        <input
          type={isPin ? "password" : "text"}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      )}

      {isPin && (
        <div style={{ marginTop: 10, height: 5, background: "#ccc" }}>
          <div
            style={{
              width: `${getPinStrength(value)}%`,
              height: 5,
              background:
                getPinStrength(value) < 40
                  ? "red"
                  : getPinStrength(value) < 70
                  ? "orange"
                  : "green",
            }}
          />
        </div>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}

      <button onClick={save} style={{ marginTop: 20 }}>
        Hifadhi
      </button>
    </div>
  );
};

export default EditField;